<template>
  <div>
    <el-row>
      <div style="float:right;">
        <el-date-picker v-model="time" type="datetimerange"
          :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
        </el-date-picker>
        <el-input placeholder="实例" clearable v-model="searchInstance" style="width: 100px;margin-left: 10px"></el-input>
        <el-input placeholder="类型" clearable v-model="searchType" style="width: 100px;margin-left: 10px"></el-input>
        <el-input placeholder="搜索" clearable v-model="searchInput" style="width: 300px;margin-left: 10px">
          <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
        </el-input>
      </div>
    </el-row>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="startTime" label="开始时间" width="200"></el-table-column>
      <el-table-column align="center" prop="endTime" label="结束时间" width="200"></el-table-column>
      <el-table-column align="center" prop="property" label="类型" width="100"></el-table-column>
      <el-table-column align="center" prop="status" label="级别" width="50"></el-table-column>
      <el-table-column align="center" prop="instance" label="实例" width="200"></el-table-column>
      <el-table-column align="center" prop="summary" label="标题" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" prop="description" label="告警详情" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "AlertInfo",
  data() {
    return {
      searchInstance:"",
      searchType:"",
      time:"",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      searchInput:"",
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  created() {
    this.time = [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7),new Date()];


    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList() {
      let data = {
        startTime: new Date(this.time[0]).getTime(),//转换13位时间戳
        endTime: new Date(this.time[1]).getTime(),
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: this.searchType,
        instance: this.searchInstance,
        keyword: this.searchInput
      }
      this.$axios.post(this.alertUrl + 'query', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data.data && data.data.length > 0) {
              this.tableData = data.data;
              this.totalElement = data.total;
            } else {
              this.tableData = [];
              this.totalElement = 0;
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
          }
        })
        .catch(err => {
          console.log(err)
        })
    }

  }
}
</script>

<style scoped>
.fy {
  text-align: center;
  margin-top: 30px;
}
</style>
